<template>
  <section class='login'>
    <div class="flex-wrapper">
      <div class="content">
        <div class="content-wrap">
          <div class='group'>
            <img :src="logo" alt="Broodje dunner logo">
          </div>

          <div class='group'>
            <LoginForm v-if="!forbidLogin"/>

            <div v-else>
              <h3>Login afgeschermd</h3>

              <p class="light">Inloggen is om veiligheidsredenen niet mogelijk in een web browser. Download of open
                de Broodje Dunner app om verder te gaan.</p>

              <StoreButtons style="margin-bottom:0" />
            </div>
          </div>

          <router-link
              :to='{name: "public.howItWorks"}'
              class='underline'
              style="margin-bottom: 10px;"
          >
            Hoe werkt het?
          </router-link>

          <router-link
              :to='{name: "public.resetPassword"}'
              class='underline reset-password'
          >
            Wachtwoord vergeten?
          </router-link>
        </div>
      </div>

      <div class="image">
        <img :src="image" alt="Login image for Broodje Dunner">
      </div>
    </div>
  </section>
</template>

<script>
import LoginForm from "@/components/blocks/LoginForm.vue";
import background from "@/assets/images/login-background.jpeg";
import logo from "@/assets/images/logo.svg";
import {
  doGet,
  doPost,
} from '@/http';
import {Capacitor} from "@capacitor/core";
import StoreButtons from "@/components/blocks/StoreButtons.vue";

export default {
  name: "Login",
  components: {
    StoreButtons,
    LoginForm,
  },
  data() {
    return {
      image: background,
      logo: logo,
      forbidLogin: import.meta.env.VITE_LOCK_FRONTEND_IN_BROWSER !== 'false' && !Capacitor.isNativePlatform(),
    };
  },
  async mounted() {
    console.log('native: ' + Capacitor.isNativePlatform());
    console.log('lock from env: ' + import.meta.env.VITE_LOCK_FRONTEND_IN_BROWSER);
    console.log('forbid condition: ' + import.meta.env.VITE_LOCK_FRONTEND_IN_BROWSER !== 'false' && !Capacitor.isNativePlatform());
  },
};
</script>
